<template>
  <div class="header-right-presentation">
    <ControlActionHistories v-if="showControlActionHistories" :is-mobile="true"></ControlActionHistories>
    <div>
      <SyncLoading />
    </div>
    <div class="-mt-1">
      <aha-button
        @click="addSlideToPowerpoint()"
        :submitting="loadingAddSlideToPPT"
        :disabled="loadingAddSlideToPPT"
        class="mr-2"
        v-if="isEnableAddinPowerpoint"
      >
        Add this slide
      </aha-button>
      <div class="inline-block">
        <aha-icon
          name="close"
          class="btn-close__icon"
          v-if="isEnableAddinPowerpoint"
          @click="closeEdit"
        />
      </div>
      <aha-button @click="turnOffTabContent" v-if="!isEnableAddinPowerpoint">
        {{ $i18nPresenter.t('Done') }}
      </aha-button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SyncLoading from '@/components-v2/presentation-editor/editor-header/SyncLoading'
import ControlActionHistories from '@/components-v2/presentation-editor/editor-header/ControlActionHistories'
import office from '@/services/office'
import config from '@/config'
import Socket from '@/socket'

export default {
  components: {
    ControlActionHistories,
    SyncLoading,
  },
  data() {
    return {
      loadingAddSlideToPPT: false,
    }
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
      isEnableAddinPowerpoint: (state) => state.isEnableAddinPowerpoint,
    }),
    showControlActionHistories() {
      return this.slideActive.activeTab === 2
    },
  },
  methods: {
    turnOffTabContent() {
      this.$store.state.activeModelDetailSlide = false
    },
    async addSlideToPowerpoint() {
      this.loadingAddSlideToPPT = true
      await office.saveDataToSlidePowerPoint('dataSlidePPT', {
        presentationId: this.presentation.id,
        slideId: this.slideActive.id,
      })
      office.setDataSlideInPowerpointToState(this.presentation.id, this.slideActive.id)

      this.$store.state.presentation.activeSlide = this.$store.state.slideActive.id
      const payloadSlide = {
        activeSlide: this.$store.state.slideActive.id,
        socketId: Socket.getSocketId(),
        accessCode: this.$store.state.presentation.uniqueAccessCode,
        timestamp: new Date().getTime(),
      }
      await this.$http.put(config.api.updateNextSlide + this.$store.state.presentation.id, payloadSlide)

      const payloadPresenting = {
        presenting: true,
        socketId: Socket.getSocketId(),
        activeSlidePreseting: this.$store.state.slideActive.id,
        activeSlideAccessCode: this.$store.state.presentation.uniqueAccessCode,
        presentFromPPT: true,
      }

      await this.$http
        .put(config.api.updatePresentation + this.$store.state.presentation.id, payloadPresenting)
      setTimeout(() => {
        window.location.href = `${config.presenterDomain}/presentation/${this.presentation.id}?presenting=true`
      }, 500)
    },
    closeEdit() {
      this.turnOffTabContent()
      if (this.$store.state.isNewPresentation) return
      this.$store.state.isOpenEditSlidePowerPoint = false
    },
  },
}
</script>

<style lang="scss" scoped>
.header-right-presentation {
  @apply relative flex h-full shadow-top bg-base-0;
  @apply items-center justify-end w-full pl-3.5 pr-4;
  @apply z-10 h-14 md:h-15 md:hidden;

  .container-action-history{
    display: flex;
  }

  & ::v-deep {
    .header-present-btn {
      display: none;
    }
  }
}
.btn-close__icon {
  cursor: pointer;
}
</style>
